import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./MissionVision.css";
import { motion } from "framer-motion";

const MissionVision = () => {
  return (
    <section className="mission-vision-section py-5">
      <div className="container position-relative">
        <div className="row g-5">
          <div className="col-12 col-md-6">
            <motion.div
              className="p-4 rounded-3 shadow-sm"
              style={{
                backgroundColor: "#333",
                color: "#fff",
              }}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <h3
                className="fw-bold mb-3 missionvision-title"
                style={{
                  color: "#ff781f",
                  fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2rem" },
                }}
              >
                Misión
              </h3>
              <p className="missionvision-text">
                Ofrecer soluciones tecnológicas integrales que potencien la
                productividad de nuestros clientes, promoviendo la innovación
                continua, la calidad en el servicio y la construcción de
                relaciones duraderas basadas en la confianza.
              </p>
            </motion.div>
          </div>

          <div className="col-12 col-md-6">
            <motion.div
              className="p-4 rounded-3 shadow-sm"
              style={{
                backgroundColor: "#333",
                color: "#fff",
              }}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <h3
                className="fw-bold mb-3 missionvision-title"
                style={{
                  color: "#ff781f",
                  fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2rem" },
                }}
              >
                Visión
              </h3>
              <p className="missionvision-text">
                Consolidarnos como una empresa líder a nivel nacional en
                soluciones informáticas y tecnológicas, reconocida por su
                profesionalismo, compromiso y capacidad de adaptación a los
                nuevos retos digitales.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
